
<footer class="footer">
  <v-container class="pa-6">
    <v-row>
      <v-col cols="12" sm="9">
        <v-row>
          <v-col>
            <div class="brand">
              <img src="/assets/images/bw-legal-logo-inverted.svg" class="bw-logo" width="112px" height="30px" alt="BW Legal Logo"/>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pr-sm-8 footer__text">
            <p class="mb-4 mb-sm-0">
              <span class="text-no-wrap"> BW Legal </span> is a trading style of <span class="text-no-wrap"> BW Legal </span> Services Limited which is a company registered in England and Wales under company registration number 07966978.
            </p>
            <p class="mb-4 mb-sm-0">
              Authorised and Regulated by the Solicitors Regulation Authority under number 569773.
            </p>
            <p class="mb-4 mb-sm-0">
              Authorised and Regulated by the Financial Conduct Authority in relation to consumer debt collection under registered number 619068.
            </p>
            <p class="mb-4 mb-sm-0">
              <span class="text-no-wrap"> BW Legal </span> Registered Office: Enterprise House, 1 Apex View, Leeds, West Yorkshire, LS11 9BH.
            </p>
            <p class="mb-4 mb-sm-0">
              This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
            <div class="my-8">
              <iframe src="https://cdn.yoshki.com/iframe/55849r.html" frameborder="0" scrolling="no" title="Solicitors Regulation Authority" class="sra-frame"></iframe>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="footer__links">
        <v-row>
          <v-col>
            <h2>Help</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ul class="footer__list pb-4">
              <li>
                <router-link :to="{name: 'Accreditations'}">
                  Accreditations
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Accessibility' }">
                  Accessibility
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Privacy' }">
                  Privacy & Cookies
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'TermsOfUse' }">
                  Terms of use
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Complaints' }">
                  Complaints
                </router-link>
              </li>                  
              <li>
                <a href="https://www.csa-uk.com/page/codesandstandards" target="parent" title="CSA Code">CSA Code</a>
              </li>
              <li>
                <a href="/assets/forms/BW-Legal-Carbon-Reduction-Plan.pdf" target="parent" title="Carbon Reduction Plan">Carbon Reduction Plan</a>
              </li>
              <li>
                <router-link :to="{ name: 'Careers' }">
                  Careers
                </router-link>
              </li>   
              <li>
                <router-link :to="{ name: 'MediaEnquiries' }">
                  Media enquiries
                </router-link>
              </li>                                
              <li>
                <router-link :to="{ name: 'ContactUs' }">
                  Contact us
                </router-link>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="9" order="last" order-sm="first" align-self="center">
        <div>
          &copy; {{ new Date().getFullYear() }} — <strong>BW Legal</strong>
        </div>
      </v-col>
    </v-row> 
  </v-container>
</footer>
